import { TOKEN_KEY as GOCHAT_TOKEN_KEY } from '../../api'
import { TOKEN_KEY as GOSAAS_TOKEN_KEY } from '../../gosaas-api'
import * as types from '../types'

const state = () => ({
  isLoggedIn: false,
  user: {
    email: '',
    token: ''
  },
  merchant: {},
  token: "",
  sendingProduct: false,
})

const getters = {
  [types.IS_LOGGED_IN]: (state) => {
    return state.isLoggedIn
  },
  [types.USER]: (state) => {
    return state.user
  },
  [types.MERCHANT]: (state) => {
    return state.merchant
  },
  [types.TOKEN]: (state) => {
    return state.token
  },
  [types.SENDING_PRODUCT]: (state) => {
    return state.sendingProduct
  },
}

const mutations = {
  [types.MUTATE_LOGIN]: (state, payload) => {
    // console.log(payload);
    state.isLoggedIn = true
    state.user = payload.user
    state.merchant = payload.merchant
    state.token = payload.token
    state.sendingProduct = false
    window.localStorage.setItem(GOCHAT_TOKEN_KEY, payload.token)
  },
  [types.MUTATE_LOGOUT]: (state) => {
    state.isLoggedIn = false
    state.user = null
    state.merchant = null
    state.token = ""
    state.sendingProduct = false
    window.localStorage.removeItem(GOCHAT_TOKEN_KEY)
    window.localStorage.removeItem(GOSAAS_TOKEN_KEY)
  },
  [types.MUTATE_START_SENDING_PRODUCT]: (state) => {
    state.sendingProduct = true
  },
  [types.MUTATE_END_SENDING_PRODUCT]: (state) => {
    state.sendingProduct = false
  }
}

const actions = {
  [types.LOGIN]: ({ commit }, payload) => {
    commit(types.MUTATE_LOGIN, payload)
  },
  [types.LOGOUT]: ({ commit }) => {
    commit(types.MUTATE_LOGOUT)
  },
  [types.START_SENDING_PRODUCT]: ({ commit }) => {
    commit(types.MUTATE_START_SENDING_PRODUCT)
  },
  [types.END_SENDING_PRODUCT]: ({ commit }) => {
    commit(types.MUTATE_END_SENDING_PRODUCT)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex-store/modules/auth.js